
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobile/[...path]",
      function () {
        return require("private-next-pages/mobile/[...path].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobile/[...path]"])
      });
    }
  